import React, { useState } from "react";

export default function TextInputForm(Props) {
  const handleUpperCase = () => {
    let newCount = count.toUpperCase();
    setcount(newCount);
  };
  const handleLowerCase = () => {
    let newCount = count.toLowerCase();
    setcount(newCount);
  };
  const handleonChange = (event) => {
    setcount(event.target.value);
  };
  const handleReset = () => {
    let newCount = "";
    setcount(newCount);
  };

  const handleCopy =()=>{
    navigator.clipboard.writeText(count)
  }

  const [count, setcount] = useState("");

  return (
    <>
      <div>
        <div className="form-floating">
          <textarea
            className="form-control"
            placeholder="Leave a comment here/"
            id="floatingTextarea2"
            style={{ height: "300px", boxShadow: "2px 2px 2px green", fontSize: "1.4rem"}}
            value={count}
            onChange={handleonChange}
          ></textarea>
          <label htmlFor="floatingTextarea2"></label>
        </div>

        <button
          type="button"
          className="btn btn-success my-3 mx-3"
          onClick={handleUpperCase} 
        >
          UpperCase
        </button>
        <button
          type="button"
          className="btn btn-success mx-3 "
          onClick={handleLowerCase}
        >
          LowerCase
        </button>
        <button
          type="button"
          className="btn btn-success mx-3 "
          onClick={handleReset}
        >
          ClearText
        </button>
        <button
          type="button"
          className="btn btn-success mx-3 "
          onClick={handleCopy}
        >
          CopyText
        </button>
      </div>
      <div className="container">
        <h1>Text Summary</h1>
        <p>
          Words: {count.split("").length}{" "}
          <span>Characters: {count.length} </span>
        </p>
      </div>
    </>
  );
}
